"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductPromotionsMaterialSearchModel = instanceOfProductPromotionsMaterialSearchModel;
exports.ProductPromotionsMaterialSearchModelFromJSON = ProductPromotionsMaterialSearchModelFromJSON;
exports.ProductPromotionsMaterialSearchModelFromJSONTyped = ProductPromotionsMaterialSearchModelFromJSONTyped;
exports.ProductPromotionsMaterialSearchModelToJSON = ProductPromotionsMaterialSearchModelToJSON;
exports.ProductPromotionsMaterialSearchModelToJSONTyped = ProductPromotionsMaterialSearchModelToJSONTyped;
/**
 * Check if a given object implements the ProductPromotionsMaterialSearchModel interface.
 */
function instanceOfProductPromotionsMaterialSearchModel(value) {
    return true;
}
function ProductPromotionsMaterialSearchModelFromJSON(json) {
    return ProductPromotionsMaterialSearchModelFromJSONTyped(json, false);
}
function ProductPromotionsMaterialSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'wsppmPromotionsNo': json['wsppmPromotionsNo'] == null ? undefined : json['wsppmPromotionsNo'],
        'materialName': json['materialName'] == null ? undefined : json['materialName'],
        'materialCode': json['materialCode'] == null ? undefined : json['materialCode'],
        'wsppdUseStatus': json['wsppdUseStatus'] == null ? undefined : json['wsppdUseStatus'],
    };
}
function ProductPromotionsMaterialSearchModelToJSON(json) {
    return ProductPromotionsMaterialSearchModelToJSONTyped(json, false);
}
function ProductPromotionsMaterialSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'wsppmPromotionsNo': value['wsppmPromotionsNo'],
        'materialName': value['materialName'],
        'materialCode': value['materialCode'],
        'wsppdUseStatus': value['wsppdUseStatus'],
    };
}
